import React from 'react';

import { Icon, IconProps } from '@chakra-ui/react';

export const OrganizationIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 160 160"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
  >
    <path d="M160 0H0V160H160V0Z" fill="#EEEEEE" />
    <path
      d="M80.0002 78.2896V35.531C80.0002 32.628 77.7711 30.4 74.8668 30.4H23.5335C20.6292 30.4 18.4001 32.628 18.4001 35.531V124.469C18.4001 127.372 20.6292 129.6 23.5335 129.6H136.467C139.371 129.6 141.6 127.372 141.6 124.469V83.4207C141.6 80.5176 139.371 78.2896 136.467 78.2896H80.0002ZM69.7335 112.497H28.6668V102.234H69.7335V112.497ZM69.7335 91.9724H28.6668V81.7103H69.7335V91.9724ZM69.7335 71.4482H28.6668V61.1862H69.7335V71.4482ZM69.7335 50.9241H28.6668V40.662H69.7335V50.9241ZM110.8 119.338H100.533V109.076H110.8V119.338ZM110.8 98.8138H100.533V88.5517H110.8V98.8138ZM90.2668 119.338H80.0002V109.076H90.2668V119.338ZM90.2668 98.8138H80.0002V88.5517H90.2668V98.8138ZM131.333 119.338H121.067V109.076H131.333V119.338ZM131.333 98.8138H121.067V88.5517H131.333V98.8138Z"
      fill="white"
    />
  </Icon>
);
